/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import RoleTraining from "components/widgets/training/RoleTraining";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import { Trans } from "react-i18next";

class RoleTrainings extends Component {
  state = {
    sort_by: "trName", // training name by default
    sort_dir: "desc",
  };

  trType = "";
  trName = "";
  trLocation = "";
  trDuration = "";
  trQuota = "";
  trStartDate = "";
  trEndDate = "";

  reOrder = (orderBy) => {
    let sort_dir = "asc";
    if (this.state.sort_dir === "asc") sort_dir = "desc";
    this.setState({
      sort_by: orderBy,
      sort_dir: sort_dir,
    });
  };

  setSotingClassNames = () => {
    this.trType = "";
    this.trName = "";
    this.trLocation = "";
    this.trDuration = "";
    this.trQuota = "";
    this.trStartDate = "";
    this.trEndDate = "";
    switch (this.state.sort_by) {
      case "trType":
        this.trType = `_${this.state.sort_dir}`;
        break;
      case "trName":
        this.trName = `_${this.state.sort_dir}`;
        break;
      case "trLocation":
        this.trLocation = `_${this.state.sort_dir}`;
        break;
      case "trDuration":
        this.trDuration = `_${this.state.sort_dir}`;
        break;
      case "trQuota":
        this.trQuota = `_${this.state.sort_dir}`;
        break;
      case "trStartDate":
        this.trStartDate = `_${this.state.sort_dir}`;
        break;
      case "trEndDate":
        this.trEndDate = `_${this.state.sort_dir}`;
        break;
      default:
        this.trName = `_${this.state.sort_dir}`;
        break;
    }
  };

  renderData = () => {
    const sorted = this.props.data.sort((a, b) => {
      switch (this.state.sort_by) {
        case "trName":
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
        case "trLocation":
          return this.state.sort_dir === "desc"
            ? (a.trainingLocation ?? "").localeCompare(b.trainingLocation ?? "")
            : (b.trainingLocation ?? "").localeCompare(a.trainingLocation ?? "")
        case "trDuration":
          return this.state.sort_dir === "desc"
            ? (a.timeplans !== null ? a.timeplans[0]?.duration : 0) -
                (b.timeplans !== null ? b.timeplans[0]?.duration : 0)
            : (b.timeplans !== null ? b.timeplans[0]?.duration : 0) -
                (a.timeplans !== null ? a.timeplans[0]?.duration : 0);
        case "trQuota":
          return this.state.sort_dir === "desc"
            ? (a.timeplans !== null ? a.timeplans[0]?.availableQuota : 0) -
                (b.timeplans !== null ? b.timeplans[0]?.availableQuota : 0)
            : (b.timeplans !== null ? b.timeplans[0]?.availableQuota : 0) -
                (a.timeplans !== null ? a.timeplans[0]?.availableQuota : 0)
        case "trStartDate":
          return this.state.sort_dir === "desc"
              ? new Date(a.timeplans !== null ? a.timeplans[0]?.startDate : 0) -
                  new Date(b.timeplans !== null ? b.timeplans[0]?.startDate : 0)
              : new Date(b.timeplans !== null ? b.timeplans[0]?.startDate : 0) -
                  new Date(a.timeplans !== null ? a.timeplans[0]?.startDate : 0)
        case "trEndDate":
          return this.state.sort_dir === "desc"
              ? new Date(a.timeplans !== null ? a.timeplans[0]?.endDate : 0) -
                  new Date(b.timeplans !== null ? b.timeplans[0]?.endDate : 0)
              : new Date(b.timeplans !== null ? b.timeplans[0]?.endDate : 0) -
                  new Date(a.timeplans !== null ? a.timeplans[0]?.endDate : 0)
        case "trType":
          return this.state.sort_dir === "desc"
            ? a.trainingMethod.label.localeCompare(b.trainingMethod.label)
            : b.trainingMethod.label.localeCompare(a.trainingMethod.label);
        default:
          return this.state.sort_dir === "desc"
            ? a.training.name.localeCompare(b.training.name)
            : b.training.name.localeCompare(a.training.name);
      }
    });

    return sorted.map((t) => {
      return <RoleTraining key={t.key} t={t} />;
    });
  };

  render() {
    this.setSotingClassNames();
    return (
      <div
        className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
        id="kayitliEgitimler"
        style={{ display: "block" }}
      >
        <table
          className="table display responsive tgE dataTable no-footer dtr-none collapsed"
          id="dataTablePersonel"
        >
          <thead>
            <tr>
              <th
                onClick={() => this.reOrder("trType")}
                className={`all sorting${this.trType}`}
              >
                <div className="tableTitle">
                  <Trans desc="Tür">10014</Trans>
                </div>
              </th>
              <th
                onClick={() => this.reOrder("trName")}
                className={`all sorting${this.trName}`}
              >
                <div className="tableTitle">
                  <Trans desc="Eğitim Adı">10015</Trans>
                </div>
              </th>
              <DesktopBreakpoint>
                <th
                  onClick={() => this.reOrder("trLocation")}
                  className={`desktop sorting${this.trLocation}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Yer">10016</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trQuota")}
                  className={`desktop sorting${this.trQuota}`}
                >
                  <div className="tableTitle">Kontenjan</div>
                </th>
                <th
                  onClick={() => this.reOrder("trDuration")}
                  className={`desktop sorting${this.trDuration}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Süre">10017</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trStartDate")}
                  className={`desktop sorting${this.trStartDate}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Başlangıç">10020</Trans>
                  </div>
                </th>
                <th
                  onClick={() => this.reOrder("trEndDate")}
                  className={`desktop sorting${this.trEndDate}`}
                >
                  <div className="tableTitle">
                    <Trans desc="Bitiş">10021</Trans>
                  </div>
                </th>
                <th className="desktop">
                  <div className="tableTitle">Talep</div>
                </th>
                <th className="none"></th>
              </DesktopBreakpoint>
            </tr>
          </thead>
          <tbody>
            {this.renderData()}
          </tbody>
        </table>
      </div>
    );
  }
}

export default RoleTrainings;
